import { useContext } from 'react';

import { ReviewRequestContext } from '../contexts';
import { ReviewRequestContextProps } from '../contexts/types';

export function useReviewRequest(): ReviewRequestContextProps {
    return useContext(ReviewRequestContext);
}
